import React from 'react';

import { StyledBox, StyledTypography } from 'styles/common';

import { StyledTextField } from './styles';

const CustomRatio = ({ disabled, handleChange, pluginMetric }) => (
  <StyledBox topGutter={3}>
    <StyledTypography variant="body2" color="grey">
      (A) Enter your custom Numerator query here
    </StyledTypography>
    <StyledTextField
      placeholder="Enter Numerator"
      variant="outlined"
      onChange={(e) => handleChange('query', e.target.value)}
      value={pluginMetric.query}
      disabled={disabled}
    />

    <StyledTypography variant="body2" color="grey">
      (B) Enter your custom Denominator query here
    </StyledTypography>
    <StyledTextField
      placeholder="Enter Denominator"
      variant="outlined"
      onChange={(e) => handleChange('ratioQuery', e.target.value)}
      value={pluginMetric.ratioQuery}
      disabled={disabled}
    />
  </StyledBox>
);

export default CustomRatio;
